module.exports = __webpack_public_path__ + "img/img28.e969cc5a.svg";